import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Meta } from 'types/meta';
import { getTranslation } from 'localization/helpers';
import { Rating } from 'styles/Form/Rating';
import { RatingStar } from 'styles/Form/RatingStar';
import { TagsText } from 'styles/Form/TagsText';
import { RateSlider } from 'client/components/RateSlider';
import { Mark } from '@material-ui/core';
import { Review } from 'types/review';

export const RatingBox: FC<{
  meta: Meta;
  index: number;
  review: Review;
  setReview: React.Dispatch<React.SetStateAction<Review>>;
}> = ({ meta, index, review, setReview }) => {
  const { t, i18n } = useTranslation();
  const [starHovered, setStarHovered] = useState(-1);

  const ratings = [
    t('ratingVeryBad'),
    t('ratingBad'),
    t('ratingMiddle'),
    t('ratingGood'),
    t('ratingVeryGood')
  ];

  const marks: Mark[] = [];
  for (let i = 1; i <= 10; i++) {
    marks.push({
      value: i,
      label: <p>{i}</p>
    });
  }

  const handleChange = (event: any, newValue: number | number[]) => {
    review.additionalQuestions[index].rating = newValue as number;
    review.additionalQuestions[index].ratingError = false;
  };

  return (
    <>
      <TagsText color={meta.color}>
        {getTranslation(
          review.additionalQuestions[index].translations,
          'question',
          i18n.language,
          meta.default_locale
        )}
      </TagsText>
      {review.additionalQuestions[index].isNPS ? (
        <>
          <RateSlider
            defaultValue={review.additionalQuestions[index].rating}
            valueLabelDisplay="off"
            track={false}
            onChange={handleChange}
            min={1}
            max={10}
            marks={marks}
            step={1}
          />
        </>
      ) : (
        <Rating>
          {ratings.map((_, rating) => (
            <RatingStar
              icon={
                rating <= review.additionalQuestions[index].rating ||
                rating <= starHovered
                  ? 'star'
                  : 'star-empty'
              }
              color={
                review.additionalQuestions[index].ratingError &&
                starHovered === -1
                  ? '#d90429'
                  : meta.color
              }
              iconSize={40}
              key={rating}
              onClick={() => {
                const tmpAdditionalQuestions = review.additionalQuestions;
                tmpAdditionalQuestions[index].rating = rating;
                tmpAdditionalQuestions[index].ratingError = false;
                setReview({
                  ...review,
                  additionalQuestions: tmpAdditionalQuestions
                });
              }}
              onMouseOver={() => {
                setStarHovered(rating);
              }}
              onMouseLeave={() => setStarHovered(-1)}
            />
          ))}
        </Rating>
      )}
    </>
  );
};
